export function makeMinCharactersValidator<T>(minCharacters: number, errorMsg: T, getException?: () => boolean) {
  return (value: string) => {
    const isException = getException && getException();

    if (isException) {
      return undefined;
    }

    const validatingValue = (typeof value === 'string' && value) || '';

    if (validatingValue.trim().length < minCharacters) {
      return errorMsg;
    }

    return undefined;
  };
}
